import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';
import { supabase } from '../config/supabase';

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const [sessionReady, setSessionReady] = useState(false);
  const [sessionError, setSessionError] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        const hash = window.location.hash.slice(1);
        const params = new URLSearchParams(hash);
        const access_token = params.get('access_token');
        const refresh_token = params.get('refresh_token');

        if (!access_token) {
          setSessionError('Lien invalide ou expiré.');
          setSessionReady(true);
          return;
        }

        const { error } = await supabase.auth.setSession({ access_token, refresh_token });
        if (error) {
          setSessionError(error.message);
        }

        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
      } catch (e) {
        setSessionError(e.message || 'Une erreur est survenue.');
      } finally {
        setSessionReady(true);
      }
    };
    run();
  }, []);

  if (!sessionReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-700">Chargement…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-h1 text-gray-900">
          {t('auth.resetPassword') || 'Reset Your Password'}
        </h2>
        <p className="mt-2 text-center text-body text-gray-600">
          {t('auth.resetPasswordInstructions') || 'Enter your new password below'}
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        {sessionError && (
          <div className="mb-4 rounded-md bg-red-50 p-4 text-sm text-red-700">
            {sessionError}
          </div>
        )}
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
